/* eslint-disable max-len */
const CURRENT_SWEEPSTAKES_ID = 'fifa-2026'; // Use 'generic' afterwards

const PURCHASER_STATE = {
  id: 'purchaser',
  name: 'FIFA World Cup 2026™',
  description: 'If Pro purchasers wish to enter, they must do so in a separate personal account. Sign in or create an account to enter for a chance to win.',
  imageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/FIFA_Icon_White.svg',
  status: 'New',
  tasks: [],
  termsAndConditions: '**NO PURCHASE NECESSARY.** Open 3/19–4/22/26. Open to legal residents age 18+ of the 50 U.S., DC, Guam, Puerto Rico, and the U.S. Virgin Islands. Odds vary. Void where prohibited. [Official Rules](https://www.homedepot.com/c/fifa-world-cup-2026-sweepstakes). Sponsor: Home Depot Store Support, Inc.',
  challengeMetaData: {
    type: 'SWEEPSTAKES',
    sweepstakesCard_description: 'If Pro purchasers wish to enter, they must do so in a separate personal account. Sign in or create an account to enter for a chance to win.',
  },
};

const UNAUTHENTICATED_SWEEPSTAKES_STATES = {
  generic: {
    id: 'generic-unauthenticated',
    name: 'Enter to Win!',
    description: 'Get up to 5 chances to win a trip with free tickets & more.',
    imageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/FIFA_Icon_White.svg',
    status: 'New',
    tasks: [],
    challengeMetaData: {
      type: 'SWEEPSTAKES',
      sweepstakesCard_description: 'Get up to 5 chances to win a trip with free tickets & more.',
    },
  },
  'fifa-2026': {
    id: 'fifa-2026-unauthenticated',
    name: 'FIFA World Cup 2026™',
    description:
      'Get up to 5 chances to win a trip with free tickets & more.',
    imageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/FIFA_Icon_White.svg',
    status: 'New',
    tasks: [],
    termsAndConditions: '**NO PURCHASE NECESSARY.** Open 3/19-4/22/26. Open to legal residents age 18+ of the 50 U.S., DC, Guam, Puerto Rico, and the U.S. Virgin Islands. Odds vary. Void where prohibited. [Official Rules](https://www.homedepot.com/c/fifa-world-cup-2026-sweepstakes). Sponsor: Home Depot Store Support, Inc.',
    challengeMetaData: {
      type: 'SWEEPSTAKES',
      sweepstakesCard_description: 'Get up to 5 chances to win a trip with free tickets & more.',
    },
  },
};

const BASE_CHALLENGE_PROFILE = {
  challengeId: 'fifa-2026',
  customerChallengeId: '85197cc0-9a6a-422b-b292-bf686a901957',
  name: 'FIFA World Cup 2026™',
  description: 'Participate in 4 different ways for a chance to win tickets to a FIFA World Cup 2026™ soccer match!',
  imageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/FIFA_Icon_White.svg',
  endDate: '04/22/2026',
  challengeStatus: 'ACTIVE',
  termsAndConditions: '**NO PURCHASE NECESSARY.** Open 3/19-4/22/26 to legal residents 18+ of 50 US, DC, Guam, PR, & USVI. Odds vary. Void where prohibited. [Official Rules](https://www.homedepot.com/c/fifa-world-cup-2026-sweepstakes). Sponsor: Home Depot Store Support, Inc.',
  challengeStepsTotal: 4,
};

const BASE_CHALLENGE_METADATA = {
  bonusEntry_postText: '**Victory! Bonus Entry Unlocked**',
  bonusEntry_preText: '**Complete all 4 entries, earn a 5th on us!**',
  bonusEntry_img: 'true',
  bonusEntryEligible: 'true',
  sweepstakesCard_description: 'Get up to 5 chances to win a trip with free tickets & more.',
  stepTrackerIcon: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/Soccerball.svg%203.svg',
  inactiveStepTrackerIcon: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/inactiveStepperIcon.svg',
  preOptInBannerImage: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/FIFA_Prizes-Banner-Sawdust-All-Vector.svg',
  preOptInDrawer_backgroundImage: 'sweepstakes-field-bg.jpeg',
  preOptInDrawer_headerLine1: 'FIFA WORLD CUP 2026™',
  preOptInDrawer_headerLine2: 'SWEEPSTAKES',
  preOptInDrawer_description: 'Here\'s your chance to be a part of history in the making. Let\'s get rolling!',
  preOptInDrawer_prizesHeading: 'You Could Win',
  preOptInDrawer_prize_1: '**Grand Prize**\\n\\nTrip for two to the FIFA World Cup 2026™ Finals with tickets, a $10,000 The Home Depot® Gift Card and a $500 Visa® Gift Card (1 winner)',
  preOptInDrawer_prize_2: '**2nd Prize**\\n\\nPair of group or knockout stage match tickets (10 winners)',
  preOptInDrawer_prize_3: '**3rd Prize**\\n\\nOfficial FIFA World Cup 2026™ replica ball (500 winners)',
  preOptInDrawer_cta: 'Let\'s Do This',
  preOptInDrawer_checkbox_1: 'I agree to receive The Home Depot communications via email. I can always update my preferences later.',
  preOptInDrawer_checkbox_2: 'I agree to the [Official Rules](https://www.homedepot.com/c/fifa-world-cup-2026-sweepstakes)',
  preOptInDrawer_checkbox_3: 'I agree to the [Privacy Policy](https://www.homedepot.com/privacy/privacy-and-security-statement)',
  'Sweeps FAQ\'s': 'https://www.homedepot.com/c/fifa-world-cup-2026',
  type: 'SWEEPSTAKES',
  typeOfChallenge: 'sweepstakes',
};

const OPTED_IN_METADATA = {
  bonusEntry_preText: '*Complete all 4 entries, earn a 5th on us!**',
  stepTracker_postOptIn_preRequistie_drawer_description: 'To participate and earn your first entry, fill out the survey by selecting the task below. Earn more entries for a better chance to win by completing the other tasks.\n\nAll additional entries are optional and can be completed in any order of events.',
  stepTracker_leanrMore_text: '[Learn more](https://www.homedepot.com/c/fifa-world-cup-2026) about how the Home Depot is gearing up for the FIFA World Cup 2026™.\nLet\'s get you World Cup ready!',
  sweepstakesCard_description: 'You\'re in, more chances to win are in your hands. ',
};

// New API format tasks with video step (uses metaData field like real API)
export const RAW_SWEEPSTAKES_TASKS = [
  {
    customerTaskId: '1c828641-e479-4c0c-bfd4-ad2a96070f88',
    sequenceNumber: 1,
    name: 'Submit Form',
    description:
      'Here\'s your chance to be a part of history in the making.\n'
      + 'Let\'s get rolling!\n\n'
      + '**The Prizes**\n'
      + '* **Grand Prize:** Trip for two to the FIFA World Cup 2026™ Finals '
      + 'with tickets, a $10,000 The Home Depot® Gift Card and a $500 Visa® '
      + 'Gift Card (1 winner)\n'
      + '* **2nd Prize:** Pair of group or knockout stage match tickets '
      + '(10 winners)\n'
      + '* **3rd Prize:** Official FIFA World Cup 2026™ replica ball '
      + '(500 winners)',
    status: 'NOT_STARTED',
    metaData: {
      ctaDescription: 'Lets Do This',
      showDrawerAppCta: 'true',
    },
  },
  {
    customerTaskId: '84073d73-312d-4e75-a2df-3f8573cb511f',
    sequenceNumber: 2,
    name: 'Meet the App',
    status: 'NOT_STARTED',
    metaData: {
      brightcoveVideoId: '6390504407112',
      prerequisitessteps: '1',
      stepDescription:
        'Welcome to The Home Depot App, your personal DIY assistant.'
        + ' Let\'s unpack tools like Same-Day Delivery, Store Mode'
        + ' & Magic Apron to help you do more on the go.',
      ctaDescription: 'Watch Now',
      ctaDrawerDescription: 'Submit Entry',
      showDrawerAppCta: 'true',
    },
  },
  {
    customerTaskId: '4635b96c-5a6f-4744-adef-0883ddcd4c95',
    sequenceNumber: 3,
    name: 'Get Fast Delivery',
    status: 'NOT_STARTED',
    metaData: {
      ctaUrl: 'http://thd.to/62eqlrjko',
      ctaAction: 'loyalty-benefits.sweepstakes_step-cta_shop',
      prerequisitessteps: '1',
      stepDescription:
        'Get what you need, fast in The Home Depot App with same-day'
        + ' and free next-day delivery (subject to availability).'
        + ' Then track your order\'s progress in real time.\n\n'
        + '**To Start Shopping in the App:**\n\n'
        + '1. Find an item to purchase\n'
        + '2. Select "Add to Cart"\n'
        + '3. Select "Proceed to Checkout"\n'
        + '4. Get it delivered to your door',
      ctaDescription: 'Start Shopping',
      showDrawerAppCta: 'true',
    },
  },
  {
    customerTaskId: 'f9493266-9842-4383-8686-752c7bc19a30',
    sequenceNumber: 4,
    name: 'Try Store Mode',
    description:
      'Store Mode unlocks time-saving tools in your Home Depot'
      + ' store. Tap into an item\'s exact location, price,'
      + ' customer reviews & more. You can even save your faves'
      + ' as you shop.\n\n'
      + '**To Start Shopping in the App:**\n\n'
      + '1. Visit a Home Depot Store\n'
      + '2. Open The Home Depot App and select "Store Mode"\n\n'
      + '![Store Mode](https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/Sweepstakes/store_mode_tracker.svg)',
    status: 'NOT_STARTED',
    metaData: {
      ctaUrl: 'https://thd.to/62eqlrjko',
      ctaAction: 'loyalty-benefits.sweepstakes_step-cta_store-mode',
      prerequisitessteps: '1',
      ctaDescription: 'Find My Store',
      showDrawerAppCta: 'false',
    },
  },
];

const CHALLENGE_METADATA = {
  ...BASE_CHALLENGE_METADATA,
  bonusEntry_postText: '**Victory! Bonus Entry Unlocked**',
  bonusEntry_preText: '*Finish all four & get a bonus entry on us**',
  bonusEntry_img: 'false',
  sweepstakesCard_description:
    'Get up to 5 chances to win a trip with free tickets & more',
  sweepstakesCard_completed_description:
    'You\'ve earned all 5 entries to win free tickets & more',
  sweepstakesCard_inProgress_description:
    'You\'re in the game. Keep earning more entries to win '
    + 'free tickets & more',
  sweepstakesDrawer_completed_description:
    '**Congrats!** You\'ve maxed out your chances to win.',
  stepTracker_postOptIn_preRequistie_drawer_description:
    'Simply fill out this form to score your first entry.'
    + '\n\n**To Earn Entries:**',
  inProgress_cta: 'Keep Earning Entries',
  completed_cta: 'Review Entries',
  fifa_drawer_icon:
    'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com'
    + '/Sweepstakes/FIFA_Icon.svg',
  all_entries_completed_text:
    'All tasks completed! 4 entries earned.\n'
    + 'The winners will be selected and notified through email '
    + 'by 04/29/2026.',
  info_text: 'Watch the video until the end to earn your entry.',
};

const sanitizeCompletedTaskIndexes = (completedTaskIndexes = []) => {
  return completedTaskIndexes.filter((index) => Number.isInteger(index) && index > 0);
};

const normalizeRawApiTasks = (rawApiTasks = []) => {
  return rawApiTasks.map((task, index) => ({
    ...task,
    sequenceNumber: task.sequenceNumber || index + 1,
    status: task.status || 'NOT_STARTED',
  }));
};

const createTasksForState = ({ rawApiTasks = RAW_SWEEPSTAKES_TASKS, completedTaskIndexes = [] } = {}) => {
  const normalizedTasks = normalizeRawApiTasks(rawApiTasks);
  const completedSet = new Set(sanitizeCompletedTaskIndexes(completedTaskIndexes));

  return normalizedTasks.map((task) => ({
    ...task,
    status: completedSet.has(task.sequenceNumber) ? 'COMPLETED' : 'NOT_STARTED',
  }));
};

export function createSweepstakesMockState({
  optedStatus = 'NOT_OPTED',
  activityStatus = 'ELIGIBLE',
  challengeStepsCompleted = 0,
  challengeStepsTotal = BASE_CHALLENGE_PROFILE.challengeStepsTotal,
  completedTaskIndexes = [],
  rawApiTasks = RAW_SWEEPSTAKES_TASKS,
  challengeOverrides = {},
  metadataOverrides = {},
} = {}) {
  const isOptedIn = optedStatus === 'OPTED_IN';

  const challengeMetaData = {
    ...BASE_CHALLENGE_METADATA,
    ...(isOptedIn ? OPTED_IN_METADATA : {}),
    ...metadataOverrides,
  };

  return {
    ...BASE_CHALLENGE_PROFILE,
    ...challengeOverrides,
    optedStatus,
    activityStatus,
    challengeStepsCompleted,
    challengeStepsTotal,
    tasks: createTasksForState({ rawApiTasks, completedTaskIndexes }),
    challengeMetaData,
  };
}

export const buildSweepstakesVariantsFromRawTasks = ({
  rawApiTasks = RAW_SWEEPSTAKES_TASKS,
  variantDefinitions = {},
  baseOptions = {},
} = {}) => {
  return Object.entries(variantDefinitions).reduce((acc, [variantKey, variantConfig]) => {
    acc[variantKey] = createSweepstakesMockState({
      ...baseOptions,
      ...variantConfig,
      rawApiTasks,
    });

    return acc;
  }, {});
};

export const createSweepstakesMockScenarioMap = () => {
  const variantDefinitions = {
    notOptedIn: {
      optedStatus: 'NOT_OPTED',
      activityStatus: 'ELIGIBLE',
      challengeStepsCompleted: 0,
      completedTaskIndexes: [],
      metadataOverrides: {
        bonusEntry_preText: '**Complete all 4 entries, earn a 5th on us!**',
        stepTracker_postOptIn_preRequistie_drawer_description: undefined,
        stepTracker_leanrMore_text: undefined,
        all_entries_completed_text: undefined,
      },
    },
    partiallyCompleted: {
      optedStatus: 'OPTED_IN',
      activityStatus: 'OPTED_IN',
      challengeStepsCompleted: 2,
      completedTaskIndexes: [1, 2],
      metadataOverrides: {
        all_entries_completed_text: 'All tasks completed! 4 entries earned.\nThe winners will be selected and notified through email by 04/29/2026.',
      },
    },
    fullyCompleted: {
      optedStatus: 'OPTED_IN',
      activityStatus: 'OPTED_IN',
      challengeStepsCompleted: 4,
      completedTaskIndexes: [1, 2, 3, 4],
      metadataOverrides: {
        all_entries_completed_text: 'All tasks completed! 4 entries earned.\nThe winners will be selected and notified through email by 04/29/2026.',
      },
    },
  };

  const variants = buildSweepstakesVariantsFromRawTasks({ variantDefinitions });

  return {
    unauthenticated: UNAUTHENTICATED_SWEEPSTAKES_STATES[CURRENT_SWEEPSTAKES_ID],
    purchaser: PURCHASER_STATE,
    ...variants,
  };
};

export const SWEEPSTAKES_MOCK_DATA = {
  ...createSweepstakesMockScenarioMap(),
  // Client-side sentinel flag — not a real API response shape.
  // Used by docs/examples to trigger the challenge-ended empty state.
  challengeEnded: {
    challengeEnded: true,
  },
};

const CHAPTER_VARIANT_DEFINITIONS = {
  NOT_OPTED_EXPIRED: {
    optedStatus: 'NOT_OPTED',
    activityStatus: 'ELIGIBLE',
    challengeStepsCompleted: 0,
    completedTaskIndexes: [],
    challengeOverrides: { endDate: '01/01/2026', challengeStatus: 'EXPIRED' },
    metadataOverrides: {
      ...CHALLENGE_METADATA,
      bonusEntry_preText: '**Complete all 4 entries, earn a 5th on us!**',
      sweepstakesEndedDescription: 'The sweepstakes has ended.',
      stepTracker_postOptIn_preRequistie_drawer_description: undefined,
      stepTracker_leanrMore_text: undefined,
      all_entries_completed_text: undefined,
    },
  },
  NOT_OPTED: {
    optedStatus: 'NOT_OPTED',
    activityStatus: 'ELIGIBLE',
    challengeStepsCompleted: 0,
    completedTaskIndexes: [],
    metadataOverrides: {
      ...CHALLENGE_METADATA,
      bonusEntry_preText: '**Complete all 4 entries, earn a 5th on us!**',
      stepTracker_postOptIn_preRequistie_drawer_description: undefined,
      stepTracker_leanrMore_text: undefined,
      all_entries_completed_text: undefined,
    },
  },
  OPTED_0_STEPS: {
    optedStatus: 'OPTED_IN',
    activityStatus: 'OPTED_IN',
    challengeStepsCompleted: 0,
    completedTaskIndexes: [],
    metadataOverrides: CHALLENGE_METADATA,
  },
  OPTED_1_STEPS: {
    optedStatus: 'OPTED_IN',
    activityStatus: 'OPTED_IN',
    challengeStepsCompleted: 1,
    completedTaskIndexes: [1],
    metadataOverrides: CHALLENGE_METADATA,
  },
  OPTED_13_STEPS: {
    optedStatus: 'OPTED_IN',
    activityStatus: 'OPTED_IN',
    challengeStepsCompleted: 2,
    completedTaskIndexes: [1, 3],
    metadataOverrides: CHALLENGE_METADATA,
  },
  OPTED_124_STEPS: {
    optedStatus: 'OPTED_IN',
    activityStatus: 'OPTED_IN',
    challengeStepsCompleted: 3,
    completedTaskIndexes: [1, 2, 4],
    metadataOverrides: CHALLENGE_METADATA,
  },
  OPTED_1234_STEPS: {
    optedStatus: 'OPTED_IN',
    activityStatus: 'OPTED_IN',
    challengeStepsCompleted: 4,
    completedTaskIndexes: [1, 2, 3, 4],
    metadataOverrides: {
      ...CHALLENGE_METADATA,
      all_entries_completed_text: 'All tasks completed! 4 entries earned.\nThe winners will be selected and notified through email by 04/29/2026.',
      sweepstakesCard_description: 'Maximum entries earned. Here\'s a bonus on us.',
    },
  },
  OPTED_1234_STEPS_ENDED: {
    optedStatus: 'OPTED_IN',
    activityStatus: 'OPTED_IN',
    challengeStepsCompleted: 4,
    completedTaskIndexes: [1, 2, 3, 4],
    challengeOverrides: { endDate: '01/01/2026' },
    metadataOverrides: {
      ...CHALLENGE_METADATA,
      all_entries_completed_text: 'All tasks completed! 4 entries earned.\nThe winners will be selected and notified through email by 04/29/2026.',
      sweepstakesCard_description: 'Maximum entries earned. Here\'s a bonus on us.',
      display_challenge_until: '2026-04-29',
      sweepstakesEndedDescription: 'The sweepstakes has ended. Winners will be notified via email',
    },
  },
  OPTED_PARTIAL_STEPS_ENDED: {
    optedStatus: 'OPTED_IN',
    activityStatus: 'INCOMPLETE',
    challengeStepsCompleted: 2,
    completedTaskIndexes: [1, 2],
    challengeOverrides: { endDate: '01/01/2026', challengeStatus: 'EXPIRED' },
    metadataOverrides: {
      ...CHALLENGE_METADATA,
      completed_cta: 'Review Entries',
      display_challenge_until: '2026-04-29',
      sweepstakesEndedDescription: 'The sweepstakes has ended. Winners will be notified via email',
    },
  },
  OPTED_0_STEPS_EXPIRED: {
    optedStatus: 'OPTED_IN',
    activityStatus: 'OPTED_IN',
    challengeStepsCompleted: 0,
    completedTaskIndexes: [],
    challengeOverrides: { endDate: '01/01/2026', challengeStatus: 'EXPIRED' },
    metadataOverrides: {
      ...CHALLENGE_METADATA,
      completed_cta: 'Review Entries',
      display_challenge_until: '2026-04-29',
      sweepstakesEndedDescription: 'The sweepstakes has ended. Winners will be notified via email',
    },
  },
};

export const SWEEPSTAKES_CHAPTER_MOCKS = buildSweepstakesVariantsFromRawTasks({
  variantDefinitions: CHAPTER_VARIANT_DEFINITIONS,
});

export const SWEEPSTAKES_OPT_IN_CONTENT = {
  title: 'WIN FIFA WORLD CUP TICKETS!',
  content: 'Want to be there when the world watches history unfold? Here\'s your chance to win exclusive '
    + 'FIFA World Cup tickets—and the more you participate, the better your chances!\n\n'
    + '**How It Works**\n\n'
    + 'Earn entries by completing fun and simple tasks. Each task you complete adds more entries to your '
    + 'name, boosting your odds of winning the ultimate soccer experience.\n\n'
    + '**The More You Do, The Better Your Odds!**\n\n'
    + 'Track your progress, unlock achievements, and climb the leaderboard. Every action brings you '
    + 'closer to the pitch.\n\n'
    + '**To Get Started**\n\n'
    + 'Enter the sweepstakes and earn your first entry by taking the survey below!\n\n'
    + '**The Winning Prizes**\n\n'
    + '**First Prize:** One winner and guest will receive an all expenses paid trip to the World Cup '
    + 'Finals in New York (July 18-20, 2026), and a FIFA World Cup backyard makeover!\n\n'
    + '* Roundtrip flights and accommodations\n'
    + '* Visa gift card for food and beverage\n'
    + '* Official FIFA World Cup gifting\n'
    + '* Backyard makeover by The Home Depot\n\n'
    + '**Second Prize:** Ten winners will receive a pair of match tickets in preferred market of choice '
    + '(travel not included).\n\n'
    + '**Third Prize:** Around 800 winners will receive an official FIFA World Cup Replica Ball!',
  ctaTitle: 'Take Survey',
  termsText: 'I agree to the terms and conditions',
  associateText: 'I confirm I am not an associate',
};

export const SWEEPSTAKES_SURVEY_CONTENT = {
  title: 'SURVEY',
  content: '',
  ctaTitle: 'Let\'s Do This!',
};

export const SWEEPSTAKES_DETAILS_CONTENT = {
  title: 'Sweepstakes Details',
  initialParagraph: 'You\'ve officially joined the sweepstakes! Earn more entries for a better chance to win by '
    + 'completing the tasks below.\n\nAll additional entries are optional and can be completed in any order of events.',
  stepsHeader: 'To Earn Sweepstakes Entries:',
  expiresText: 'Expires 4/09/2026',
  termsAndConditions: '**NO PURCHASE NECESSARY.** Open 3/19–4/22/26. Open to legal residents age 18+ of the 50 U.S., DC, Guam, Puerto Rico, and the U.S. Virgin Islands. Odds vary. Void where prohibited. [Official Rules](https://www.homedepot.com/c/fifa-world-cup-2026-sweepstakes). Sponsor: Home Depot Store Support, Inc.',
};

export const SWEEPSTAKES_AVAILABLE_PERKS_COUNT = {
  availablePerks: 5,
  expiringPerks: 2,
  daysLeft: 7,
  availableOffers: 10,
  expiringOffers: 3,
  daysLeftForOffers: 14,
  enrolledInChallenges: true,
  challengeTitles: ['Spring Savings Challenge', 'DIY Expert Challenge'],
  sweepstakes: [{
    title: 'FIFA World Cup 2026™',
    image: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/FIFA_Icon.svg',
    totalEntriesAvailable: 4,
    totalEntriesCompleted: 1,
    displaySweepStakeChallenge: true // based on 'show till date' from meta data
  }]
};
